var _defs, _path, _path2, _path3, _path4, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBillingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 169 202.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#414851;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84,105.49a48.45,48.45,0,1,1,47.28-58.9l.57,2.55-2.61.18a44.9,44.9,0,0,0-41,53.39l.49,2.56-3.3.16C84.91,105.46,84.45,105.49,84,105.49ZM84,13.1A43.94,43.94,0,0,0,83.33,101a48.66,48.66,0,0,1-.48-6.76,49.71,49.71,0,0,1,43.39-49.13A44.2,44.2,0,0,0,84,13.1Z",
    transform: "translate(-13 -8.6)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.43,143.8A49.58,49.58,0,1,1,182,94.22,49.63,49.63,0,0,1,132.43,143.8Zm0-94.64a45.07,45.07,0,1,0,45.06,45.06A45.11,45.11,0,0,0,132.43,49.16Z",
    transform: "translate(-13 -8.6)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.8,211.4a33.8,33.8,0,1,1,33.8-33.8A33.84,33.84,0,0,1,46.8,211.4Zm0-63.1a29.3,29.3,0,1,0,29.29,29.3A29.33,29.33,0,0,0,46.8,148.3Z",
    transform: "translate(-13 -8.6)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M144.59,84.78a6.06,6.06,0,0,1-1,1,2.07,2.07,0,0,1-1.3.36,2.81,2.81,0,0,1-1.47-.39l-1.46-.87a11.69,11.69,0,0,0-1.9-.86,8.2,8.2,0,0,0-2.72-.39,7.65,7.65,0,0,0-3.47.74,6.46,6.46,0,0,0-2.41,2.12,9.44,9.44,0,0,0-1.41,3.36,19.9,19.9,0,0,0-.46,4.5q0,5.25,2,8.07a6.49,6.49,0,0,0,5.58,2.82,7.78,7.78,0,0,0,3-.48,9.19,9.19,0,0,0,1.88-1.06l1.43-1.07a2.62,2.62,0,0,1,1.64-.49,2.24,2.24,0,0,1,2,1l3.17,3.91a17,17,0,0,1-3.56,3.15,18,18,0,0,1-3.82,1.91,20.63,20.63,0,0,1-3.93.95,30.09,30.09,0,0,1-3.84.26,16.42,16.42,0,0,1-6.4-1.27,15.49,15.49,0,0,1-5.35-3.68,17.57,17.57,0,0,1-3.67-5.94,22.34,22.34,0,0,1-1.36-8A22.8,22.8,0,0,1,117,86.91a16.77,16.77,0,0,1,3.49-6,16.4,16.4,0,0,1,5.71-4,20.07,20.07,0,0,1,7.88-1.44,19.29,19.29,0,0,1,7.54,1.37,18.23,18.23,0,0,1,5.85,4Z",
    transform: "translate(-13 -8.6)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 119.43,
    y: 58.59,
    width: 4.51,
    height: 54.08
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingIcon);
export default __webpack_public_path__ + "static/media/billing-icon.4d5a3d0b4ad51dd202366580812ff666.svg";
export { ForwardRef as ReactComponent };